import { OrganizationProfile } from "schemas/dashboard";

import { AboutYouType, BestWorkType, WritingStyleSource } from "./schema";

type StoredDefaults = {
  aboutYouItem?: AboutYouType;
  bestWorkItem?: BestWorkType;
  writingStyleSource?: WritingStyleSource;
};

const storageKey = (orgId: number | string) => `templateStep2Defaults:${orgId}`;

export const readTemplateDefaults = (
  orgId: number | string | undefined,
): StoredDefaults => {
  if (!orgId) return {};
  try {
    const raw = window.localStorage.getItem(storageKey(orgId));
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

export const writeTemplateDefaults = (
  orgId: number | string | undefined,
  next: StoredDefaults,
) => {
  if (!orgId) return;
  try {
    const merged = { ...readTemplateDefaults(orgId), ...next };
    window.localStorage.setItem(storageKey(orgId), JSON.stringify(merged));
  } catch {
    // localStorage can throw on quota/private mode; safe to ignore.
  }
};

export const truncateValue = (s: string, max = 60) =>
  s.length > max ? `${s.slice(0, max)}…` : s;

export const iconForAboutYou = (item: AboutYouType): string => {
  switch (item) {
    case "portfolioUrl":
      return "fa-solid fa-link";
    case "introduction":
      return "fa-solid fa-user";
  }
};

export const iconForBestWork = (item: BestWorkType): string => {
  switch (item) {
    case "portfolioUrl":
      return "fa-solid fa-link";
    case "mostEngagedPost":
      return "fa-solid fa-fire";
    case "contentExamplePost":
      return "fa-solid fa-handshake";
    case "socialMediaPage":
      return "fa-solid fa-share-nodes";
    case "mostImpressivePartnerships":
      return "fa-solid fa-trophy";
  }
};

export const formatAboutYouSummary = (
  item: AboutYouType,
  profile: OrganizationProfile | null | undefined,
): string => {
  switch (item) {
    case "portfolioUrl": {
      const url = profile?.portfolioUrl?.trim();
      return url ? `From portfolio: ${truncateValue(url)}` : "From portfolio";
    }
    case "introduction":
      return "From your own written introduction";
  }
};

export const formatBestWorkSummary = (item: BestWorkType): string => {
  switch (item) {
    case "portfolioUrl":
      return "From portfolio";
    case "mostEngagedPost":
      return "From top performing post";
    case "contentExamplePost":
      return "From brand collab post";
    case "socialMediaPage":
      return "From social media page";
    case "mostImpressivePartnerships":
      return "From most impressive partnership";
  }
};
